import PropTypes from 'prop-types';
import UserProp from '../../../commonComponents/propTypes/userProp';
import {
  GAME_EVENT_TYPES,
  LEAD_CONDITIONS,
  TROPHY_CONFIG,
} from '../../../services/utilityFunctions';

const propType = {
  _id: PropTypes.string.isRequired,
  user1: PropTypes.shape(UserProp.propType),
  user2: PropTypes.shape(UserProp.propType),
  position1: PropTypes.number,
  position2: PropTypes.number,
  type: PropTypes.oneOf(GAME_EVENT_TYPES).isRequired,
  info: PropTypes.string,
  likes: PropTypes.number,
  comments: PropTypes.number,
  isLiked: PropTypes.bool,
  trophy: PropTypes.shape({
    type: PropTypes.oneOf(Object.keys(TROPHY_CONFIG)),
  }),
  date: PropTypes.number.isRequired,
  lead: PropTypes.shape({}),
  leadCondition: PropTypes.oneOf(LEAD_CONDITIONS),
};

export default { propType };
